// Bikram Sambat ↔ Gregorian converter.
// Lookup table: days in each Nepali month for BS years 2000-2099.
// Base epoch: 1943-04-14 AD = 2000-01-01 BS (Baisakh 1, 2000).
// Source: widely used community table (Kathmandu Post / nepali-date-converter).

const BS_MONTH_DAYS = {
    2000: [30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
    2001: [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
    2002: [31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
    2003: [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
    2004: [30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
    2005: [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
    2006: [31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
    2007: [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
    2008: [31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 29, 31],
    2009: [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
    2010: [31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
    2011: [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
    2012: [31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30],
    2013: [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
    2014: [31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
    2015: [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
    2016: [31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30],
    2017: [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
    2018: [31, 32, 31, 32, 31, 30, 30, 29, 30, 29, 30, 30],
    2019: [31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
    2020: [31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
    2021: [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
    2022: [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30],
    2023: [31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
    2024: [31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
    2025: [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
    2026: [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30],
    2027: [30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
    2028: [31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
    2029: [31, 31, 32, 31, 32, 30, 30, 29, 30, 29, 30, 30],
    2030: [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30],
    2031: [31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
    2032: [31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
    2033: [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
    2034: [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30],
    2035: [30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
    2036: [31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
    2037: [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
    2038: [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30],
    2039: [31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
    2040: [31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
    2041: [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
    2042: [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30],
    2043: [31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
    2044: [31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
    2045: [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
    2046: [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30],
    2047: [31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
    2048: [31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
    2049: [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
    2050: [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30],
    2051: [31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
    2052: [31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
    2053: [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
    2054: [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30],
    2055: [31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
    2056: [31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
    2057: [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
    2058: [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30],
    2059: [31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
    2060: [31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
    2061: [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
    2062: [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30],
    2063: [31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
    2064: [31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
    2065: [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
    2066: [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30],
    2067: [31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
    2068: [31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
    2069: [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
    2070: [31, 32, 31, 32, 31, 30, 30, 29, 30, 29, 30, 30],
    2071: [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
    2072: [31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
    2073: [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
    2074: [31, 32, 31, 32, 31, 30, 30, 29, 30, 29, 30, 30],
    2075: [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
    2076: [31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
    2077: [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
    2078: [31, 32, 31, 32, 31, 30, 30, 29, 30, 29, 30, 30],
    2079: [31, 31, 32, 32, 31, 30, 30, 30, 29, 29, 30, 31],
    2080: [31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 30, 30],
    2081: [31, 31, 32, 32, 31, 30, 30, 30, 29, 30, 30, 30],
    2082: [30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 30, 30],
    2083: [31, 31, 32, 31, 31, 30, 30, 30, 29, 30, 30, 30],
    2084: [31, 31, 32, 31, 31, 30, 30, 30, 29, 30, 30, 30],
    2085: [31, 32, 31, 32, 30, 31, 30, 30, 29, 30, 30, 30],
    2086: [30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 30, 30],
    2087: [31, 31, 32, 31, 31, 31, 30, 30, 29, 30, 30, 30],
    2088: [30, 31, 32, 32, 30, 31, 30, 30, 29, 30, 30, 30],
    2089: [30, 31, 32, 32, 31, 30, 30, 30, 29, 30, 30, 30],
    2090: [30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 30, 30],
    2091: [31, 31, 32, 31, 31, 31, 30, 30, 29, 30, 30, 30],
    2092: [30, 31, 32, 32, 31, 30, 30, 30, 29, 30, 30, 30],
    2093: [30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 30, 30],
    2094: [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
    2095: [31, 31, 32, 31, 31, 31, 30, 30, 29, 30, 30, 30],
    2096: [30, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
    2097: [31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 30, 30],
    2098: [31, 31, 32, 31, 31, 31, 29, 30, 29, 30, 29, 31],
    2099: [31, 31, 32, 31, 31, 31, 30, 29, 29, 30, 30, 30],
};

const NP_MONTHS_EN = [
    "Baisakh", "Jestha", "Ashadh", "Shrawan", "Bhadra", "Ashwin",
    "Kartik", "Mangsir", "Poush", "Magh", "Falgun", "Chaitra",
];
const NP_MONTHS_NE = [
    "बैशाख", "जेठ", "असार", "साउन", "भदौ", "असोज",
    "कार्तिक", "मंसिर", "पुष", "माघ", "फागुन", "चैत",
];

// Reference: 2000 BS Baisakh 1 = 1943-04-14 AD
const REF_AD = new Date(Date.UTC(1943, 3, 14));

function totalDaysFromBs(y, m, d) {
    let days = 0;
    for (let year = 2000; year < y; year++) {
        const arr = BS_MONTH_DAYS[year];
        if (!arr) throw new Error("BS year out of range: " + year);
        days += arr.reduce((a, b) => a + b, 0);
    }
    const arr = BS_MONTH_DAYS[y];
    if (!arr) throw new Error("BS year out of range: " + y);
    for (let month = 1; month < m; month++) days += arr[month - 1];
    days += d - 1;
    return days;
}

export function bsToAd(y, m, d) {
    const days = totalDaysFromBs(y, m, d);
    const ad = new Date(REF_AD.getTime() + days * 86400000);
    return {
        year: ad.getUTCFullYear(),
        month: ad.getUTCMonth() + 1,
        day: ad.getUTCDate(),
    };
}

export function adToBs(y, m, d) {
    const target = Date.UTC(y, m - 1, d);
    let diff = Math.floor((target - REF_AD.getTime()) / 86400000);
    if (diff < 0) throw new Error("Date before 1943-04-14 AD not supported");

    let year = 2000,
        month = 1,
        day = 1;
    while (diff > 0) {
        const arr = BS_MONTH_DAYS[year];
        if (!arr) throw new Error("BS year out of range: " + year);
        const daysThisMonth = arr[month - 1];
        if (diff >= daysThisMonth - (day - 1)) {
            diff -= daysThisMonth - (day - 1);
            day = 1;
            month++;
            if (month > 12) {
                month = 1;
                year++;
            }
        } else {
            day += diff;
            diff = 0;
        }
    }
    return { year, month, day };
}

export function bsMonthName(m, lang = "en") {
    return lang === "ne" ? NP_MONTHS_NE[m - 1] : NP_MONTHS_EN[m - 1];
}

export function bsYearsRange() {
    return { min: 2000, max: 2099 };
}
